import { render, staticRenderFns } from "./AdicionarComissaoDialog.vue?vue&type=template&id=c28d1720&"
import script from "./AdicionarComissaoDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarComissaoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdicionarComissaoDialog.vue"
export default component.exports